import "./homeHeading.css";
import Imgs from "./homepage_images/basket.webp";
import OurServices from "./OurServices";
export default function HomeHeading() {
  return (
    <section className="sectionHomeHeading fx-cl space4 mobileRWDhide">
      <div className="HomeHeadingCont">
        <div className="HomeHeadingLeft fx-ac">
          <div className="fx-cl space2">
            <h3>
              Powerful enough for complex operations. Simple enough to use from
              day one.
            </h3>
            <aside className="fx-cl fs4 lh2">
              <p>
                All the capability you need, without all the complexity you
                don’t. No steep learning curve. No complicated processes. Just
                get to work.
              </p>
            </aside>
          </div>
          <div>
            <img src={Imgs} alt="here" />
          </div>
        </div>
        <div className="HomeHeadingRight">
          <div className="fx-cl space2">
            <h3>Deep functionality without the deep learning curve.</h3>
            <p>
              Built to carry the operational load, while you move the{" "}
              <strong>business forward</strong>.
            </p>
            <button>Learn More!</button>
          </div>
        </div>
      </div>
      <OurServices />
    </section>
  );
}
